import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/orders',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('@/views/CallbackView.vue'),
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('@/views/UnauthorizedView.vue'),
    },
    {
      path: '/orders',
      name: 'orders-list',
      component: () => import('@/views/orders/OrderList.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/orders/errored',
      name: 'orders-list-errored',
      component: () => import('@/views/orders/OrderList.vue'),
      meta: {
        requiresAuth: true,
        presetLabel: 'Errored orders (last 30 days)',
        // Factory: evaluated at navigation time so the date window slides with "today".
        presetFilter: () => {
          const cutoff = new Date()
          cutoff.setUTCDate(cutoff.getUTCDate() - 30)
          const yyyy = cutoff.getUTCFullYear()
          const mm = String(cutoff.getUTCMonth() + 1).padStart(2, '0')
          const dd = String(cutoff.getUTCDate()).padStart(2, '0')
          return `lastSyncErrorCategory!=,CreatedOn>=${yyyy}-${mm}-${dd}`
        },
      },
    },
    {
      path: '/orders/new',
      name: 'orders-create',
      component: () => import('@/views/orders/OrderCreate.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import('@/views/statistics/SparkStatistics.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/orders/:id',
      name: 'orders-detail',
      component: () => import('@/views/orders/OrderDetail.vue'),
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue'),
    },
  ],
})

// Auth guard - redirect unauthenticated users to login
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Skip auth check for public routes
  if (['login', 'callback', 'unauthorized', 'not-found'].includes(to.name as string)) {
    return next()
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  if (to.meta.requiredRoles) {
    const requiredRoles = to.meta.requiredRoles as string[]
    const hasRole = requiredRoles.some((role) => authStore.hasRole(role))
    if (!hasRole) {
      return next({ name: 'unauthorized' })
    }
  }

  next()
})
export default router